import AmplitudeHelper from '@utils/analytics';
import { AMPLITUDE_CONSTANTS } from '@utils/analytics/constants';
import { formatUnderScoreLowerCase } from '@utils/utils';
import { TFunction } from 'i18next';

interface ProductConfig {
  transaction_category_id?: string;
  reason?: string;
  reasonId?: string;
}

interface ApiPayload {
  productCode?: string;
}

interface BpError {
  [key: number]: string;
}

export default function logSubProdNominalFailure(
  selectedAccountNumber: string,
  productConfig: ProductConfig,
  apiPayload: ApiPayload,
  t: TFunction,
  bpError: BpError,
  source: string,
): void {
  const e = AMPLITUDE_CONSTANTS.BillPayment.verifyTransactionFailed;
  const { attributes } = e;

  AmplitudeHelper.logEvent(e.name, {
    [attributes.account_number]: selectedAccountNumber,
    [attributes.transaction_category_id]: productConfig?.transaction_category_id,
    [attributes.product_code]: apiPayload?.productCode,
    [attributes.reason]: productConfig?.reason,
    [attributes.reason_id]: productConfig?.reasonId,
    [attributes.failure_message]: formatUnderScoreLowerCase(t(`errorCodes.${bpError[0]}`)),
    [attributes.source]: source,
  });
}
